module.exports = __webpack_public_path__ + "img/zhuti-06.5afac805.png";